import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react'

import * as persisted from '#/state/persisted'

type StateContext = string | undefined
type SetContext = (v: string | undefined) => void

const stateContext = createContext<StateContext>(
  persisted.defaults.communityBrandColor,
)
stateContext.displayName = 'CommunityBrandColorStateContext'
const setContext = createContext<SetContext>((_: string | undefined) => {})
setContext.displayName = 'CommunityBrandColorSetContext'

export function Provider({children}: {children: React.ReactNode}) {
  const [state, setState] = useState(persisted.get('communityBrandColor'))

  const setStateWrapped = useCallback(
    (communityBrandColor: persisted.Schema['communityBrandColor']) => {
      setState(communityBrandColor)
      void persisted.write('communityBrandColor', communityBrandColor)
    },
    [setState],
  )

  useEffect(() => {
    return persisted.onUpdate(
      'communityBrandColor',
      nextCommunityBrandColor => {
        setState(nextCommunityBrandColor)
      },
    )
  }, [setStateWrapped])

  return (
    <stateContext.Provider value={state}>
      <setContext.Provider value={setStateWrapped}>
        {children}
      </setContext.Provider>
    </stateContext.Provider>
  )
}

/**
 * The current brand primary color (6-hex-digit, no `#`), if a Life app
 * flavor's color was ever set via `/community-login`. `undefined` means the
 * default ClearCommunity blue.
 */
export const useCommunityBrandColor = () => useContext(stateContext)
export const useSetCommunityBrandColor = () => useContext(setContext)
